import AssetLoader from "@/components/AssetLoader/AssetLoader";
import { AssetTypes } from "@/model/AssetTypes";
import BFDocumentView from "@/modules/abstract-ui/forms/document-editor/BFDocumentView";
import { getLetterFooter } from "@/modules/abstract-ui/forms/document-editor/BFLetterFooter";
import TextEditorUtils from "@/modules/ckeditor/TextEditorUtils";
import { TemplateAsset } from "@/modules/template-module/TemplateInterfaces";
import React, { ReactNode } from "react";
import ReactDOMServer from "react-dom/server";
import _ from "lodash";
import VacancyContractUtils from '../../../../vacancy-applicant/utils/VacancyContractUtils';
import { getVacancyContractHeader } from './VacancyContractHeader';

type Props = {
  contentNodes: ReactNode;
  suffixHtml?: string;
  prefixHtml?: string;
  letterTemplateId?: string;
  resolvedVariables?: { [key: string]: string };
  conditions?: { [key: string]: boolean };
  currentFieldEditing?: string;
};

const VacancyContractPreview = (props: Props) => {
  const {
    contentNodes,
    resolvedVariables,
    letterTemplateId,
    currentFieldEditing,
    conditions,
  } = props;

  const getContentHtml = () => {
    return ReactDOMServer.renderToString(<>{contentNodes}</>);
  };

  const prefixHtml = _.isEmpty(props.prefixHtml) ? undefined : props.prefixHtml;
  const suffixHtml = _.isEmpty(props.suffixHtml) ? undefined : props.suffixHtml;

  return (
    <BFDocumentView
      currentVariable={currentFieldEditing}
      contentHtml={
        <>
          {letterTemplateId ? (
            <AssetLoader
              id={letterTemplateId}
              assetType={AssetTypes.Template}
              render={(template: TemplateAsset) => {
                return (
                  <div
                    className={`header-html`}
                    dangerouslySetInnerHTML={{
                      __html: TextEditorUtils.replaceVariables(
                        getVacancyContractHeader(template.data.data),
                        resolvedVariables || {},
                        {
                          conditions: conditions,
                          formatFunctions:
                            VacancyContractUtils.getReplacementFormaters(),
                        }
                      ),
                    }}
                  />
                );
              }}
            />
          ) : (
            <></>
          )}
          {prefixHtml && (
            <div
              className={`prefix-html`}
              dangerouslySetInnerHTML={{
                __html: TextEditorUtils.replaceVariables(
                  prefixHtml,
                  resolvedVariables || {},
                  {
                    conditions: conditions,
                    formatFunctions:
                      VacancyContractUtils.getReplacementFormaters(),
                  }
                ),
              }}
            />
          )}
          <div
            className={`value-html`}
            dangerouslySetInnerHTML={{
              __html: TextEditorUtils.replaceVariables(
                getContentHtml() || "",
                resolvedVariables || {},
                {
                  conditions: conditions,
                  currentFieldEditing,
                  keepSpanClasses: true,
                  formatFunctions:
                    VacancyContractUtils.getReplacementFormaters(),
                }
              ),
            }}
          />
          {suffixHtml && (
            <div
              className={`suffix-html`}
              dangerouslySetInnerHTML={{
                __html: TextEditorUtils.replaceVariables(
                  suffixHtml,
                  resolvedVariables || {},
                  {
                    conditions: conditions,
                    formatFunctions:
                      VacancyContractUtils.getReplacementFormaters(),
                  }
                ),
              }}
            />
          )}
          {letterTemplateId ? (
            <AssetLoader
              id={letterTemplateId}
              assetType={AssetTypes.Template}
              render={(template: TemplateAsset) => {
                return (
                  <div
                    className={`footer-html`}
                    dangerouslySetInnerHTML={{
                      __html: TextEditorUtils.replaceVariables(
                        getLetterFooter(template.data.data),
                        resolvedVariables || {},
                        {
                          conditions: conditions,
                          formatFunctions:
                            VacancyContractUtils.getReplacementFormaters(),
                        }
                      ),
                    }}
                  />
                );
              }}
            />
          ) : (
            <></>
          )}
        </>
      }
    />
  );
};

export default VacancyContractPreview;
